export default "__VITE_ASSET__DI76TEWl__"